module.exports = __webpack_public_path__ + "static/media/unit 5-1.306efce5.jpg";